module.exports = __webpack_public_path__ + "img/hue-luminance.61027f02.jpg";